import { Badge } from "@/components/ui/badge";
import { StateBadge } from "./StateBadge";

/** Instant "a quote just landed" alerts to the team. */
export const NotificationStatus = ({ notifications, state }) => (
  <div
    data-testid="notification-status"
    className="mt-4 rounded-lg border border-border bg-[color:var(--tt-surface-2)] px-4 py-3.5"
  >
    <div className="flex flex-wrap items-center justify-between gap-2">
      <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-primary">
        Instant notifications to the team
      </p>
      <StateBadge state={state} testId="notification-status-badge" />
    </div>
    <p className="mt-2 text-[13px] leading-relaxed text-muted-foreground">
      {notifications.message}
    </p>
    <div className="mt-3 flex flex-wrap gap-1.5">
      {(notifications.events || []).map((event) => (
        <Badge
          key={event}
          variant="outline"
          className="border-[color:var(--tt-teal-line)] bg-[color:var(--tt-teal-mist)] font-normal text-[color:var(--tt-teal-deep)]"
        >
          {event}
        </Badge>
      ))}
    </div>
    <p className="mt-2.5 text-[11px] text-muted-foreground">
      Goes to{" "}
      <span
        className="font-amount font-bold text-foreground"
        data-testid="notification-recipients"
      >
        {(notifications.recipients || []).join(", ") || "Nobody set"}
      </span>
    </p>
  </div>
);
